import { CloudArrowUp, Trash } from "phosphor-react";
import React, { useState } from "react";
import ErrorOrSuccessMessage from "../ErrorOrSuccessMessage/ErrorOrSuccessMessage.component.jsx";
import useStyles from "./UploadFile.style.js";
export default function UploadFile(props) {
  const classes = useStyles();
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  return (
    <div className={classes.cardContentDiv2}>
      <ErrorOrSuccessMessage snackValue={snackValue} />
      {props.fileUploading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p style={{ fontSize: "13px" }}>{props.uploadProgress}% uploading</p>
        </div>
      ) : (
        <>
          {props.thumbnail ? (
            <div
              className={classes.displayFlex}
              style={{
                height: "100%",
              }}
            >
              <span className={classes.fileName}>
                {typeof props.thumbnail === "object"
                  ? props.thumbnail.name
                  : props.thumbnail}
              </span>
              <div
                className={classes.deleteContainer}
                onClick={(e) => {
                  props.setDeleteFileModal(true);
                  /* if (props?.thumbnail?.name) {
                  } else {
                    props.handleClearUpload();
                  } */
                }}
              >
                <Trash size={20} className={classes.closeIcon} />
              </div>
            </div>
          ) : (
            <label className={classes.label} for="thumbnailUpload">
              <div className={classes.fileIcon}>
                <CloudArrowUp size={25} />
              </div>
              <div className={classes.labelText}>
                Click to upload
                <br />
                or
                <br />
                Drag and Drop on the screen
              </div>
            </label>
          )}
          <input
            type="file"
            style={{ display: "none" }}
            accept="image/* video/*"
            id="thumbnailUpload"
            onChange={(e) => {
              if (e?.target?.files[0]?.name?.length < 100) {
                props.handleThumbnailUpload(e);
              } else {
                setSnackValue({
                  isOpen: true,
                  message: "File Name Is too big to upload",
                  isError: true,
                });
              }
            }}
          />
        </>
      )}
    </div>
  );
}
